export default __webpack_public_path__ + "static/media/wrong.b8984a96.svg";